import { render, staticRenderFns } from "./InviteCode.vue?vue&type=template&id=65741c9c&scoped=true&"
import script from "./InviteCode.vue?vue&type=script&lang=js&"
export * from "./InviteCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65741c9c",
  null
  
)

export default component.exports